import { Image } from '@chakra-ui/react';
import { setLogoUrl } from '../../constants/setLogos';

/** Wide set wordmark for filter rows. Omitted when the set has no logo asset. */
export function SetLogoThumb({ code, name }: { code: string; name?: string }) {
  const src = setLogoUrl(code, name);
  if (!src) return null;
  return (
    <Image
      src={src}
      alt=""
      draggable={false}
      flexShrink={0}
      h={{ base: '28px', md: '22px' }}
      w={{ base: '56px', md: '44px' }}
      objectFit="contain"
      objectPosition="left center"
    />
  );
}
